import React from 'react'
import PropTypes from 'prop-types'
import Poll from '../../models/Poll'
import './Masthead.less'

const sum = (result) => result.reduce((s, n) => s + n, 0)
const total = (results) =>
	Object.keys(results).reduce((t, k) => t + sum(results[k]), 0)

export default function Masthead(props) {
	return (
		<section className="masthead">
			<div className="block polls">
				<div className="number">{props.polls.length}</div>
				<div className="text">polls</div>
			</div>
			<div className="block votes">
				<div className="number">{total(props.results)}</div>
				<div className="text">votes</div>
			</div>
		</section>
	)
}

Masthead.propTypes = {
	polls: PropTypes.arrayOf(PropTypes.instanceOf(Poll)),
	results: PropTypes.object, // eslint-disable-line
}



// WEBPACK FOOTER //
// ./src/components/polls/Masthead.jsx